export default function navigate (link) {
  window.location.href = window.location.origin + link;
}
